import { createSlice } from "@reduxjs/toolkit";

export interface IDashboardState {
  loading: boolean;
  error: string;
  sessionDetails: any;
}

const initialState: IDashboardState = {
  loading: false,
  error: "",
  sessionDetails: {},
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearSessionDetails: (state) => {
      state.sessionDetails = initialState.sessionDetails;
    },
  },
});

export const {
  clearSessionDetails,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
